import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ShieldCheckIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m6.125 7.718 1.25 1.213 2.813-2.728M13 8.02c0 2.976-3.346 5.14-4.564 5.83-.138.078-.207.117-.305.137a.7.7 0 0 1-.262 0c-.098-.02-.167-.06-.305-.138C6.346 13.161 3 10.997 3 8.021V5.122c0-.485 0-.727.082-.935.072-.184.19-.349.342-.479.172-.147.406-.232.874-.403l3.35-1.219c.13-.047.196-.07.263-.08a.6.6 0 0 1 .178 0c.067.01.132.033.262.08l3.351 1.22c.468.17.702.255.874.402.153.13.27.295.342.479.082.208.082.45.082.935z" /></svg>
  );
}

export default ShieldCheckIcon;
